// @ts-strict

import { Component, OnInit, Output, Input, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ICreateTrafficSourceData } from '@app/core/services/traffic-sources/traffic-sources.types';
import { isEqual } from 'lodash';

@Component({
  selector: 'app-types-section',
  templateUrl: './types-section.component.html',
  styleUrls: ['./types-section.component.scss']
})
export class TypesSectionComponent implements OnChanges {
  @Output() selectedTrafficSourceType: EventEmitter<null | { id: number }> = new EventEmitter();
  @Input() modalConfig: ICreateTrafficSourceData[] = [];

  public mode = {
    chooseType: 'chooseType',
    chosen: 'chosen'
  };
  public currentMode = 'chooseType';
  public selectedType?: { id: number };

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!isEqual(changes.modalConfig?.previousValue, changes.modalConfig?.currentValue)) {
      this.modalConfig = this.swapLastAndPenultimate(this.modalConfig);
    }
  }

  onSelectSource($event: { id: number }): void {
    this.selectedType = $event;
    this.currentMode = this.mode.chosen;
    this.selectedTrafficSourceType.emit($event);
  }

  onChangeType(): void {
    this.currentMode = this.mode.chooseType;
    this.selectedTrafficSourceType.emit(null);
  }

  private swapLastAndPenultimate = (array: ICreateTrafficSourceData[]): ICreateTrafficSourceData[] => {
    if (array.length < 2) return array;

    let newArray = [...array.slice(0, -2), ...array.slice(-2).reverse()];

    return newArray;
  };
}
